import { widgetTypeMap } from "./enum.data";
import { mockQuerySchemaData } from "../mock/schemaData";

/**
 * 数据处理工具函数
 */

/**
 * 深拷贝对象
 * @param {*} obj - 要拷贝的对象
 * @returns {*} 拷贝后的对象
 */
export function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.map((item) => deepClone(item));
  }

  if (typeof obj === "object") {
    const clonedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  }
}

/**
 * 求笛卡尔积 为了将维度拼接
 * @params arrayList<array>
 * void array
 **/

export function calcDescartes(arrayList) {
  if (arrayList.length < 2) return arrayList[0] || [];
  return arrayList.reduce((total, currentValue) => {
    let res = [];
    total.forEach((t) => {
      currentValue.forEach((cv) => {
        if (Array.isArray(t)) res.push([...t, cv]);
        else res.push([t, cv]);
      });
    });
    return res;
  });
}

export function transferWhiteVal(val) {
  if (val === null || val === undefined || val === "") {
    return "--";
  }
  return val;
}

// 构建meta中英文映射
export function mateMapping(metas) {
  const metaMap = new Map();
  metas.forEach((m) => {
    metaMap.set(m.field, m.name);
  });
  return metaMap;
}

/**
 * 防抖函数
 * @param {Function} func - 要防抖的函数
 * @param {Number} wait - 等待时间
 * @param {Boolean} immediate - 是否立即执行
 * @returns {Function} 防抖后的函数
 */
export function debounce(func, wait, immediate = false) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
}

/**
 * 节流函数
 * @param {Function} func - 要节流的函数
 * @param {Number} limit - 限制时间
 * @returns {Function} 节流后的函数
 */
export function throttle(func, limit) {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

/**
 * 数据验证
 * @param {*} data - 要验证的数据
 * @param {String} type - 数据类型
 * @returns {Boolean} 验证结果
 */
export function validateData(data, type) {
  switch (type) {
    case "array":
      return Array.isArray(data);
    case "object":
      return data !== null && typeof data === "object" && !Array.isArray(data);
    case "string":
      return typeof data === "string";
    case "number":
      return typeof data === "number" && !isNaN(data);
    case "boolean":
      return typeof data === "boolean";
    default:
      return data !== null && data !== undefined;
  }
}

/**
 * 安全获取对象属性值
 * @param {Object} obj - 对象
 * @param {String} path - 属性路径
 * @param {*} defaultValue - 默认值
 * @returns {*} 属性值
 */
export function safeGet(obj, path, defaultValue = undefined) {
  if (!obj || typeof path !== "string") {
    return defaultValue;
  }

  const keys = path.split(".");
  let result = obj;

  for (const key of keys) {
    if (
      result === null ||
      result === undefined ||
      !result.hasOwnProperty(key)
    ) {
      return defaultValue;
    }
    result = result[key];
  }

  return result;
}

/**
 * 数组去重
 * @param {Array} arr - 要去重的数组
 * @param {String} key - 去重的键名（可选）
 * @returns {Array} 去重后的数组
 */
export function uniqueArray(arr, key) {
  if (!Array.isArray(arr)) {
    return [];
  }

  if (key) {
    const seen = new Set();
    return arr.filter((item) => {
      const value = item[key];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  }

  return [...new Set(arr)];
}

export function initFieldData(fields) {
  const isHasDrill = this.fields.some((f) => f.alias === "drill");
  if (!isHasDrill) {
    this.fields.unshift(defaultDrillField());
  }
}